module.exports = __webpack_public_path__ + "static/media/48270454_2308760545865790_4849278090209132544_o-thumb.14cd8220.jpg";